<template>
    <div class="services-container">
      <h1 class="page-title">Network & Administration Consultancy Services</h1>
  
      <div class="services-list">
        <div v-for="(service, index) in services" :key="index" class="service-item">
          <div class="service-icon">
            <img :src="service.icon" alt="service-icon" />
          </div>
          <div class="service-details">
            <h2>{{ service.name }}</h2>
            <p>{{ service.description }}</p>
            <a :href="service.link" class="service-link">Learn More</a>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script lang="ts">
  import { defineComponent, ref } from "vue";
  
  export default defineComponent({
    name: "ServicesPage",
    setup() {
      const services = ref([
        {
          name: "Network Setup & Configuration",
          description:
            "We provide end-to-end network setup services, from planning, configuring to securing your network infrastructure.",
          icon: "/assets/network-setup.png",
          link: "",
        },
        {
          name: "IT Infrastructure Management",
          description:
            "Our IT infrastructure management ensures smooth operation, offering monitoring and 24/7 support.",
          icon: "/assets/it-infrastructure.png",
          link: "",
        },
        {
          name: "Cybersecurity Solutions",
          description:
            "We offer comprehensive security solutions to protect your business from online threats, data breaches, and cyberattacks.",
          icon: "/assets/cybersecurity.png",
          link: "",
        },
        {
          name: "Cloud Solutions & Integration",
          description:
            "Helping you migrate to the cloud seamlessly, providing scalable and flexible cloud-based solutions.",
          icon: "/assets/cloud-solutions.png",
          link: "",
        },
        {
          name: "System Administration & Support",
          description:
            "Our system administration team will manage your servers, software, and workstations with expert-level support.",
          icon: "/assets/system-admin.png",
          link: "",
        },
      ]);
  
      return {
        services,
      };
    },
  });
  </script>
  
  <style scoped>
  .services-container {
    max-width: 1200px;
    margin: 0px auto;
    padding: 20px;
    background-color: #f4f4f4;
    border-radius: 10px;
  }
  
  .page-title {
    text-align: center;
    font-size: 36px;
    color: #333;
    margin-bottom: 40px;
  }
  
  .services-list {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 20px;
  }
  
  .service-item {
    background-color: #fff;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
  
  .service-icon img {
    max-width: 50px;
    margin-bottom: 20px;
  }
  
  .service-details h2 {
    font-size: 24px;
    color: #333;
    margin-bottom: 10px;
  }
  
  .service-details p {
    font-size: 16px;
    color: #555;
    margin-bottom: 20px;
  }
  
  .service-link {
    color: #4caf50;
    font-weight: bold;
    text-decoration: none;
  }
  
  .service-link:hover {
    text-decoration: underline;
  }
  </style>
  